import styled from 'styled-components'

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 200px;
  max-width: 200px;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  pointer-events: auto;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 2px 8px 2px rgba(47, 43, 61, 0.12);
  }
  padding: 4px;
  border-radius: 4px;
`
const CardImage = styled.img`
  width: 192px;
  height: 113px;
  aspect-ratio: 200/113;
  border-radius: 4px;
  object-fit: cover;
`

const CardTexts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`

const CardDate = styled.span`
  align-self: stretch;
  color: #8d8d8d;
  leading-trim: both;
  text-edge: cap;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
`

const CardTitle = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  overflow: hidden;
  color: #2c2c2c;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

const CardsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  overflow: visible;
  margin: 0 -24px;
  position: relative;
  flex-shrink: 0;
  flex-grow: 0;
  align-self: stretch;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */

  .card-list-wrapper {
    display: flex;
    gap: 16px;
    overflow-x: scroll;
    flex: 0 0 1;
    padding: 0 500% 0 24px;
    z-index: 0;
    padding-bottom: 8px;

    &::-webkit-scrollbar {
      display: none; /* For Chrome, Safari, and Opera */
    }

    pointer-events: none;

    &:hover {
      pointer-events: auto;
    }

    &::-webkit-scrollbar {
      display: none; /* For Chrome, Safari, and Opera */
    }

    &::-webkit-scrollbar-thumb {
      display: none;
    }

    &::-webkit-scrollbar-track {
      display: none;
    }
  }

  .ghost-button {
    display: flex;
    width: 50px;
    height: 100%;
    padding: 0px 4px;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    z-index: 0;
    pointer-events: auto;

    > div {
      display: flex;
      width: 40px;
      height: 40px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      border-radius: 9999px;
      background: #fff;
      cursor: pointer;
      box-shadow: 0px 0px 8px 2px rgba(47, 43, 61, 0.12);
      &:hover {
        background: #f7f7f7;
      }
    }
  }

  .ghost-button-left {
    align-items: flex-start;
    left: 0px;
    background: linear-gradient(-90deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
  }

  .ghost-button-right {
    align-items: flex-end;
    right: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 11.61%,
      #fff 100%
    );
  }
`

const Styles = {
  CardContainer,
  CardImage,
  CardTexts,
  CardDate,
  CardTitle,
  CardsWrapper,
}

export default Styles
